module.exports = __webpack_public_path__ + "static/img/two.5840b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/1/two.png
// module id = Dq8M
// module chunks = 1